export default __webpack_public_path__ + "1c827b96d8eb4e88e892bec9afa7a5eb.png";